import { Screen } from '@betty/navigation';
import { ChangePassword } from '../components';
import { KeyboardSpacer } from '@betty/moonlight';

function ChangePasswordScreen() {
  return (
    <Screen paddingBottom="safe-area-inset-bottom">
      <ChangePassword />
      <KeyboardSpacer isInsideSafeAreaView additionalOffset={-70} />
    </Screen>
  );
}
export default ChangePasswordScreen;
